export default {
  data() {
    return {
      statusName: {
        44: 'Intención de pago',
        43: 'Recado familiar',
        42: 'Operador ocupado',
        41: 'Error interno',
        40: 'En espera',
        39: 'Por eliminar',
        38: 'Gestionado',
        37: 'Proximo Contacto',
        36: 'Por eliminar',
        35: 'Sin compromiso',
        34: 'Refinanciado',
        33: 'Rechazado',
        32: 'Rechaza oferta',
        31: 'Recado conocido',
        30: 'Rebotado',
        29: 'Programado',
        28: 'Procesando Envio',
        27: 'Por enviar',
        26: 'Pagado',
        25: 'Ocupado',
        24: 'No enviado',
        23: 'No entregado',
        22: 'No contesta',
        21: 'Marcado SPAM',
        20: 'Leido',
        19: 'Invalido',
        18: 'Incidencia',
        17: 'Fuera de horario',
        16: 'Error de operador',
        15: 'Equivocado',
        14: 'Enviado',
        13: 'Entregado',
        12: 'En proceso',
        11: 'Detenido',
        10: 'Desconoce deuda',
        9: 'Conectado',
        8: 'Compromiso',
        7: 'Cesante',
        6: 'Buzon de Voz',
        5: 'Acepta oferta',
        4: '403',
        3: '402',
        2: '401',
        1: '200',
        46: 'Alternativa de pago',
        50: 'Detenido por Ley',
      },
      statusIcons: {
        5: 'check',
        6: 'user-times',
        7: 'inbox',
        8: 'calendar-check',
        9: 'headset',
        10: 'user-minus',
        11: 'hand-paper',
        12: 'clock',
        13: 'user-check',
        14: 'check',
        15: 'user-slash',
        16: 'times',
        17: 'clock',
        18: 'times',
        19: 'times',
        20: 'book-open',
        21: 'ban',
        22: 'user-clock',
        23: 'comment-slash',
        24: 'phone-slash',
        25: 'ban',
        26: 'hand-holding-usd',
        27: 'user-clock',
        28: 'hand-holding-usd',
        29: 'clipboard-check',
        30: 'voice_over_off',
        31: 'phone',
        32: 'ban',
        33: 'ban',
        34: 'hand-holding-usd',
        35: 'calendar-times',
        39: 'trash',
        44: 'calendar-check',
        43: 'phone',
        50: 'calendar-times',
        // 'Llamar luego': 'history',
      },
      customerStatus: [
        {
          id: 1,
          icon: 'folder-open',
          status: 'Sin información',
        },
        {
          id: 2,
          icon: 'calendar-check',
          status: 'Compromiso',
        },
        {
          id: 3,
          icon: 'check-double',
          status: 'Contactado',
        },
        {
          id: 4,
          icon: 'pause',
          status: 'Contenido',
        },
        {
          id: 5,
          icon: 'user-minus',
          status: 'Fuera de gestion',
        },
        {
          id: 6,
          icon: 'check',
          status: 'Gestionando',
        },
        {
          id: 7,
          icon: 'ban',
          status: 'Intentos máximos',
        },
        {
          id: 8,
          icon: 'funnel-dollar',
          status: 'Saldo bajo',
        },
        {
          id: 9,
          icon: 'phone-slash fa-rotate-90',
          status: 'SDG',
        },
        {
          id: 10,
          icon: 'hand-holding-usd',
          status: 'Abono',
        },
        {
          id: 11,
          icon: 'clock',
          status: 'Por gestionar',
        },
        {
          id: 12,
          icon: 'ban',
          status: 'Lista negra',
        },
        {
          id: 15,
          icon: 'ban',
          status: 'Sin etapa',
        },
        {
          id: 16,
          icon: 'slash',
          status: 'Sin filtros',
        },
        {
          id: 18,
          icon: 'ban',
          status: 'No gestionado',
        },
        {
          id: 19,
          icon: 'phone-slash fa-rotate-90',
          status: 'Canales ocupados',
        },
        {
          id: 20,
          icon: 'backspace',
          status: 'SDC 01',
        },
        {
          id: 21,
          icon: 'comments',
          status: 'Gestionando chat center',
        },
        {
          id: 22,
          icon: 'calendar-day',
          status: 'Vencimiento próximo mes',
        },
        {
          id: 25,
          icon: 'calendar-day',
          status: 'Contacto Ley',
        },
        {
          id: 26,
          icon: 'calendar-day',
          status: 'Contactado informativo',
        },
        {
          id: 27,
          icon: 'calendar-day',
          status: 'Proximo Contacto',
        },
        {
          id: 28,
          icon: 'user-minus',
          status: 'SDC 02',
        },
        {
          id: 29,
          icon: 'user-minus',
          status: 'SDC 03',
        },
        {
          id: 30,
          icon: 'user-minus',
          status: 'SDC 04',
        },
        {
          id: 31,
          icon: 'user-minus',
          status: 'SDC 05',
        },
        {
          id: 32,
          icon: 'user-minus',
          status: 'SDC 06',
        },
        {
          id: 33,
          icon: 'user-minus',
          status: 'SDC 07',
        },
        {
          id: 34,
          icon: 'user-minus',
          status: 'SDC 08',
        },
        {
          id: 35,
          icon: 'user-minus',
          status: 'SGL 01',
        },
        {
          id: 36,
          icon: 'user-minus',
          status: 'SGL 02',
        },
        {
          id: 37,
          icon: 'user-minus',
          status: 'IA 01',
        },
        {
          id: 38,
          icon: 'user-minus',
          status: 'IA 02',
        },
        {
          id: 39,
          icon: 'user-minus',
          status: 'IA 03',
        },
        {
          id: 40,
          icon: 'user-minus',
          status: 'IA 04',
        },
        {
          id: 41,
          icon: 'user-minus',
          status: 'IA 05',
        },
        {
          id: 42,
          icon: 'user-minus',
          status: 'IA 06',
        },
        {
          id: 43,
          icon: 'user-minus',
          status: 'SDC 09',
        },
        {
          id: 44,
          icon: 'user-minus',
          status: 'SGL 03',
        },
        {
          id: 50,
          icon: 'calendar-times',
          status: 'Contacto Ley',
        },
      ],
    };
  },
  methods: {
    showStatusName(id) {
      return this.statusName[id];
    },
    showStatusIcon(id) {
      return this.statusIcons[id];
    },
    getSpanColor(status, padding = false) {
      let color = '';
      if (!padding) {
        color = 'subheading ';
      } else {
        color = 'pl-2 ';
      }
      if (status === 12) {
        color += 'blue--text';
      } else if ([8, 14, 20, 13, 9, 26].includes(status)) {
        color += 'green--text';
      } else {
        color += 'red--text';
      }
      return color;
    },
    getCustomerField(field, value, toReturn) {
      const index = this.customerStatus.findIndex(item => item[field] === value);
      if (index !== -1) {
        return this.customerStatus[index][toReturn];
      }
      return 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/status.js